const videoSource5 = [
  {
    id: "video7",
    src: require("./1_6.mp4"),
  },
];

export default videoSource5;
